/**
 * Données Mock centralisées pour le système de gestion des échéanciers
 * Ce fichier contient toutes les données de test utilisées dans l'application
 * À remplacer par des appels API en production
 */

/**
 * Liste complète des échéanciers de paiement
 * Chaque échéancier a un ID unique et est lié à un mandat
 */
export const paymentSchedules = [
    {
        id: 1,
        mandate: 'MDT-001',
        debtor: 'Personne 1',
        debtorName: 'Personne 1',
        amount: 150.00,
        frequency: 'Mensuelle',
        frequencyType: 'recurrent',
        periodicity: 'monthly',
        nextDebitDate: '2025-01-15',
        nextDueDate: '2025-01-15',
        status: 'Actif',
        recurrenceType: 'Récurrent',
        endDate: '2026-11-15',
        occurrences: null, // Mutuellement exclusif avec endDate
        debitReason: 'Abonnement mensuel',
        firstDebitDate: '2025-01-15',
        createdAt: '2024-12-01',
        updatedAt: '2024-12-01'
    },
    {
        id: 2,
        mandate: 'MDT-002',
        debtor: 'Personne 2',
        debtorName: 'Personne 2',
        amount: 50.00,
        frequency: 'Unique',
        frequencyType: 'one-off',
        periodicity: null,
        nextDebitDate: '2025-01-15',
        nextDueDate: '2025-01-15',
        status: 'Actif',
        recurrenceType: 'Unique',
        endDate: null,
        occurrences: null,
        debitReason: 'Paiement unique',
        firstDebitDate: '2025-01-15',
        createdAt: '2024-12-02',
        updatedAt: '2024-12-02'
    },
    {
        id: 3,
        mandate: 'MDT-001',
        debtor: 'Personne 1',
        debtorName: 'Personne 1',
        amount: 100.00,
        frequency: 'Mensuelle',
        frequencyType: 'recurrent',
        periodicity: 'monthly',
        nextDebitDate: '2025-02-15',
        nextDueDate: '2025-02-15',
        status: 'Actif',
        recurrenceType: 'Récurrent',
        endDate: null,
        occurrences: 12, // Mutuellement exclusif avec endDate
        debitReason: 'Cotisation annuelle',
        firstDebitDate: '2025-02-15',
        createdAt: '2024-12-03',
        updatedAt: '2024-12-03'
    },
    {
        id: 4,
        mandate: 'MDT-003',
        debtor: 'Personne 3',
        debtorName: 'Personne 3',
        amount: 250.00,
        frequency: 'Annuelle',
        frequencyType: 'recurrent',
        periodicity: 'yearly',
        nextDebitDate: '2025-03-10',
        nextDueDate: '2025-03-10',
        status: 'Actif',
        recurrenceType: 'Récurrent',
        endDate: '2028-03-10',
        occurrences: null,
        debitReason: 'Cotisation annuelle',
        firstDebitDate: '2025-03-10',
        createdAt: '2024-12-04',
        updatedAt: '2024-12-04'
    },
    {
        id: 5,
        mandate: 'MDT-004',
        debtor: 'Personne 4',
        debtorName: 'Personne 4',
        amount: 90.00,
        frequency: 'Hebdomadaire',
        frequencyType: 'recurrent',
        periodicity: 'weekly',
        nextDebitDate: '2025-10-29',
        nextDueDate: '2025-10-29',
        status: 'Actif',
        recurrenceType: 'Récurrent',
        endDate: null,
        occurrences: 52,
        debitReason: 'Abonnement hebdomadaire',
        firstDebitDate: '2025-01-01',
        createdAt: '2024-12-05',
        updatedAt: '2024-12-05'
    },
    {
        id: 6,
        mandate: 'MDT-005',
        debtor: 'Personne 5',
        debtorName: 'Personne 5',
        amount: 40.00,
        frequency: 'Mensuelle',
        frequencyType: 'recurrent',
        periodicity: 'monthly',
        nextDebitDate: '2025-10-29',
        nextDueDate: '2025-10-29',
        status: 'Actif',
        recurrenceType: 'Récurrent',
        endDate: '2026-10-29',
        occurrences: null,
        debitReason: 'Abonnement mensuel',
        firstDebitDate: '2025-01-29',
        createdAt: '2024-12-06',
        updatedAt: '2024-12-06'
    },
    {
        id: 7,
        mandate: 'MDT-006',
        debtor: 'Personne 6',
        debtorName: 'Personne 6',
        amount: 300.00,
        frequency: 'Trimestrielle',
        frequencyType: 'recurrent',
        periodicity: 'quarterly',
        nextDebitDate: '2025-12-05',
        nextDueDate: '2025-12-05',
        status: 'Actif',
        recurrenceType: 'Récurrent',
        endDate: null,
        occurrences: 8,
        debitReason: 'Paiement trimestriel',
        firstDebitDate: '2025-03-05',
        createdAt: '2024-12-07',
        updatedAt: '2024-12-07'
    },
    {
        id: 8,
        mandate: 'MDT-002',
        debtor: 'Personne 2',
        debtorName: 'Personne 2',
        amount: 450.00,
        frequency: 'Trimestrielle',
        frequencyType: 'recurrent',
        periodicity: 'quarterly',
        nextDebitDate: '2025-07-20',
        nextDueDate: '2025-07-20',
        status: 'Actif',
        recurrenceType: 'Récurrent',
        endDate: '2026-07-20',
        occurrences: null,
        debitReason: 'Loyer trimestriel',
        firstDebitDate: '2025-01-20',
        createdAt: '2024-12-08',
        updatedAt: '2024-12-08'
    },
    {
        id: 9,
        mandate: 'MDT-003',
        debtor: 'Personne 3',
        debtorName: 'Personne 3',
        amount: 60.00,
        frequency: 'Mensuelle',
        frequencyType: 'recurrent',
        periodicity: 'monthly',
        nextDebitDate: '2025-10-29',
        nextDueDate: '2025-10-29',
        status: 'Actif',
        recurrenceType: 'Récurrent',
        endDate: null,
        occurrences: 24,
        debitReason: 'Abonnement internet',
        firstDebitDate: '2024-10-29',
        createdAt: '2024-12-09',
        updatedAt: '2024-12-09'
    }
]

/**
 * Détails des prélèvements planifiés pour chaque échéancier
 * Utilisé dans la vue détails pour afficher les prochains prélèvements
 */
export const plannedDebits = {
    1: [
        { date: '2025-01-15', amount: '150,00 €', status: 'Prévu' },
        { date: '2025-02-15', amount: '150,00 €', status: 'Prévu' },
        { date: '2025-03-15', amount: '150,00 €', status: 'Prévu' },
        { date: '2025-04-15', amount: '150,00 €', status: 'Prévu' },
        { date: '2025-05-15', amount: '150,00 €', status: 'Prévu' }
    ],
    2: [
        { date: '2025-01-15', amount: '50,00 €', status: 'Prévu' }
    ],
    3: [
        { date: '2025-02-15', amount: '100,00 €', status: 'Prévu' },
        { date: '2025-03-15', amount: '100,00 €', status: 'Prévu' },
        { date: '2025-04-15', amount: '100,00 €', status: 'Prévu' }
    ],
    4: [
        { date: '2025-03-10', amount: '250,00 €', status: 'Prévu' },
        { date: '2026-03-10', amount: '250,00 €', status: 'Prévu' },
        { date: '2027-03-10', amount: '250,00 €', status: 'Prévu' }
    ],
    5: [
        { date: '2025-10-29', amount: '90,00 €', status: 'Prévu' },
        { date: '2025-11-05', amount: '90,00 €', status: 'Prévu' },
        { date: '2025-11-12', amount: '90,00 €', status: 'Prévu' }
    ],
    6: [
        { date: '2025-10-29', amount: '40,00 €', status: 'Prévu' },
        { date: '2025-11-29', amount: '40,00 €', status: 'Prévu' },
        { date: '2025-12-29', amount: '40,00 €', status: 'Prévu' }
    ],
    7: [
        { date: '2025-12-05', amount: '300,00 €', status: 'Prévu' },
        { date: '2026-03-05', amount: '300,00 €', status: 'Prévu' },
        { date: '2026-06-05', amount: '300,00 €', status: 'Prévu' }
    ],
    8: [
        { date: '2025-07-20', amount: '450,00 €', status: 'Prévu' },
        { date: '2025-10-20', amount: '450,00 €', status: 'Prévu' },
        { date: '2026-01-20', amount: '450,00 €', status: 'Prévu' }
    ],
    9: [
        { date: '2025-10-29', amount: '60,00 €', status: 'Prévu' },
        { date: '2025-11-29', amount: '60,00 €', status: 'Prévu' },
        { date: '2025-12-29', amount: '60,00 €', status: 'Prévu' }
    ]
}

/**
 * Liste des fréquences disponibles pour les filtres
 */
export const frequencies = [
    'Mensuelle',
    'Trimestrielle',
    'Annuelle',
    'Hebdomadaire',
    'Unique'
]

/**
 * Statuts possibles pour un échéancier
 */
export const scheduleStatuses = {
    ACTIVE: 'Actif',
    PENDING: 'En attente',
    COMPLETED: 'Terminé',
    CANCELLED: 'Annulé',
    FAILED: 'Échoué'
}

/**
 * Statuts possibles pour un prélèvement
 */
export const debitStatuses = {
    PLANNED: 'Prévu',
    EXECUTED: 'Exécuté',
    FAILED: 'Échoué',
    CANCELLED: 'Annulé'
}

/**
 * Fonction utilitaire pour obtenir un échéancier par son ID
 * @param {number} id - L'ID de l'échéancier
 * @returns {object|null} L'échéancier ou null si non trouvé
 */
export function getScheduleById(id) {
    return paymentSchedules.find(schedule => schedule.id === parseInt(id)) || null
}

/**
 * Fonction utilitaire pour obtenir tous les échéanciers d'un mandat
 * @param {string} mandateRef - La référence du mandat
 * @returns {array} Liste des échéanciers du mandat
 */
export function getSchedulesByMandate(mandateRef) {
    return paymentSchedules.filter(schedule => schedule.mandate === mandateRef)
}

/**
 * Fonction utilitaire pour obtenir les prélèvements planifiés d'un échéancier
 * @param {number} scheduleId - L'ID de l'échéancier
 * @returns {array} Liste des prélèvements planifiés
 */
export function getPlannedDebitsByScheduleId(scheduleId) {
    return plannedDebits[scheduleId] || []
}

/**
 * Fonction utilitaire pour formater un montant en euros
 * @param {number} amount - Le montant à formater
 * @returns {string} Le montant formaté
 */
export function formatCurrency(amount) {
    if (amount === null || amount === undefined) return '0,00 €'
    return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR'
    }).format(amount)
}

/**
 * Fonction utilitaire pour formater une date
 * @param {string} dateString - La date au format ISO (YYYY-MM-DD)
 * @returns {string} La date formatée (DD/MM/YYYY)
 */
export function formatDate(dateString) {
    if (!dateString) return ''
    const [year, month, day] = dateString.split('-')
    return `${day}/${month}/${year}`
}

/**
 * Fonction utilitaire pour obtenir les informations d'un mandat
 * (Mock - à remplacer par un appel API)
 * @param {string} mandateRef - La référence du mandat
 * @returns {object|null} Les informations du mandat
 */
export function getMandateInfo(mandateRef) {
    const mockMandates = {
        'MDT-001': { umr: 'MDT-001', debtorName: 'Personne 1', status: 'Actif' },
        'MDT-002': { umr: 'MDT-002', debtorName: 'Personne 2', status: 'Actif' },
        'MDT-003': { umr: 'MDT-003', debtorName: 'Personne 3', status: 'Actif' },
        'MDT-004': { umr: 'MDT-004', debtorName: 'Personne 4', status: 'Actif' },
        'MDT-005': { umr: 'MDT-005', debtorName: 'Personne 5', status: 'Actif' },
        'MDT-006': { umr: 'MDT-006', debtorName: 'Personne 6', status: 'Actif' }
    }
    return mockMandates[mandateRef] || null
}
